import type { SearchProgressStage } from '../model/types';

export const SERP_PROGRESS_STAGES: readonly SearchProgressStage[] = ['operators', 'hotels', 'prices'];

export const SERP_PROGRESS_DRIFT_HALF_MS = 8000;

export const SERP_PROGRESS_TICK_MS = 250;

export const SERP_PROGRESS_FINISH_MS = 700;
